module.exports = __webpack_public_path__ + "img/vu_dark.9b8780bd.svg";